import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ImportantMessageService {

  public message = new BehaviorSubject<string>(null);
}
